import { MarketTemplate } from "../../data";
import { emptySelection, emptySelectionPointBox } from "../../constants";
export const fillEmptyMarketSelections = (template) => {
    let selections = [];
    template === MarketTemplate.PointBox && selections.push(Object.assign({}, emptySelectionPointBox));
    let counter = template === MarketTemplate.ThreeBox ? 3 : 2;
    for (let i = 0; i < counter; i++) {
        selections.push(emptySelection);
    }
    return selections;
};
//# sourceMappingURL=fillEmptyMarketSelections.js.map